module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-settings-079ce3750b7260e8a9ebe30bae9b6448.png";